
export enum TriState {
  False = 0,
  Pending = '',
  True = 1
}
